import { render, staticRenderFns } from "./womenCarnivalGame.vue?vue&type=template&id=558a357d&"
import script from "./womenCarnivalGame.vue?vue&type=script&lang=js&"
export * from "./womenCarnivalGame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports